import React from 'react';

const TableHeader: React.FC = ({ children }) => {
    return <div className="table-header">{children}</div>;
};

export default TableHeader;
